<template>
  <section class="pd4 HomeProbox" style="background-image: url(static/picture/science-lab-1.png);">
    <div class="HomeTit white wow fadeInUp">
      <h1 class="cn">{{ $t('pages.home.profile') }}</h1>
      <p class="en OswaldMedium">Profile</p>
      <!-- <a href='/AboutWe' class="bluebtn">{{ $t('pages.home.learnMore') }}</a> -->
    </div>
    <div class="scroll wow fadeInUp">
      <ul class="slider">
        <li class="item itemhover" v-for="(item, index) in items" :key="index">
          <div class="table">
            <div class="imgbox cell Scale-img"><a :href="item.link"><img :src="item.image" /></a></div>
            <div class="Info cell">
              <a :href="item.link">
                <div class="tit">{{ item.title }}</div>
                <p class="p">{{ item.description }}</p>
                <p class="bluebtn">{{ $t('pages.home.details') }}</p>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

export default {
  name: 'IndexProfile',
  setup() {
    const { t } = useI18n();
    const items = computed(() => [
      {
        link: '/AboutWe',
        image: 'static/picture/wp7549076.jpg',
        title: t('seo.title'),
        description: t('pages.home.companyDesc')
      },
    ]);
    return { items };
  }
};
</script>

<style scoped>
</style>
